import { render, staticRenderFns } from "./serviceOrder.vue?vue&type=template&id=4b67b872"
import script from "./serviceOrder.vue?vue&type=script&lang=js"
export * from "./serviceOrder.vue?vue&type=script&lang=js"
import style0 from "./serviceOrder.vue?vue&type=style&index=0&id=4b67b872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports